import React from 'react';
import { Heart, ShoppingCart, Trash2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { useWishlist } from '../context/WishlistContext';
import { useCart } from '../context/CartContext';
import ProductCard from '../components/ProductCard';
import { Button } from '../components/ui/button';

const WishlistPage = () => {
  const { language, getLocalizedText } = useLanguage();
  const { wishlist, clearWishlist } = useWishlist();
  const { addToCart } = useCart();
  const navigate = useNavigate();

  const handleAddAllToCart = () => {
    wishlist.forEach((product) => {
      addToCart(product);
    });
  };

  return (
    <div className="min-h-screen bg-black py-8 px-4">
      <div className="container mx-auto max-w-6xl">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-2xl md:text-4xl font-bold text-white mb-2">
              {language === 'hu' ? 'Kívánságlista' : 'Wishlist'}
            </h1>
            <p className="text-zinc-400">
              {wishlist.length} {language === 'hu' ? 'termék' : 'items'}
            </p>
          </div>
          
          {wishlist.length > 0 && (
            <div className="flex gap-3">
              <Button
                variant="outline"
                onClick={clearWishlist}
                className="border-zinc-700 text-zinc-400 hover:bg-zinc-800 hover:text-white"
              >
                <Trash2 className="h-4 w-4 mr-2" />
                {language === 'hu' ? 'Törlés' : 'Clear'}
              </Button>
              <Button
                onClick={handleAddAllToCart}
                className="bg-white text-black hover:bg-zinc-200"
              >
                <ShoppingCart className="h-4 w-4 mr-2" />
                {language === 'hu' ? 'Mind a kosárba' : 'Add all to cart'}
              </Button>
            </div>
          )}
        </div>

        {/* Wishlist Items */}
        {wishlist.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {wishlist.map((product) => (
              <ProductCard key={product.id} product={product} showWishlistButton />
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <Heart className="h-20 w-20 text-zinc-700 mx-auto mb-6" />
            <h2 className="text-xl font-semibold text-white mb-2">
              {language === 'hu' ? 'A kívánságlistád üres' : 'Your wishlist is empty'}
            </h2>
            <p className="text-zinc-400 mb-8">
              {language === 'hu' 
                ? 'Adj hozzá termékeket a szív ikonra kattintva' 
                : 'Add products by clicking the heart icon'}
            </p>
            <Button
              onClick={() => navigate('/hookahs')}
              className="bg-white text-black hover:bg-zinc-200"
            >
              {language === 'hu' ? 'Termékek böngészése' : 'Browse products'}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default WishlistPage;
